module.exports = __webpack_public_path__ + "img/scene_daylight_big@2x.938deba7.png";